import { Button, Form, FormInstance, Input, Select, Space, message } from "antd";
import React, { useEffect, useState } from "react";
import {
  addBranchTerms,
  fetchUserPermissions,
} from "../../../../apis/branch.api";
import { usePermissions } from "../../../../custom_hooks/permission/permission_hook";
const { Option } = Select;

export interface BranchTermsCreateProps {
  closeDrawer: Function;
  letUpdate: Function;
}
const BranchTermsCreateForm = ({
  closeDrawer,
  letUpdate,
}: BranchTermsCreateProps) => {
  const [form] = Form.useForm();
  const { hasPermission } = usePermissions();
  const canEdit = hasPermission("branch_details.create");
  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    fetchUserPermissions().then((result: any) => {
      setPermissions(result);
    });
  }, []);

  const onFinish = (updatedValues: any) => {
    if (!canEdit) {
      message.error("You don't have permission to add terms");
      return;
    }
    addBranchTerms(updatedValues).then(() => {
      closeDrawer();
      letUpdate();
    });
  };

  const SubmitButton = ({ form }: { form: FormInstance }) => {
    const [submittable, setSubmittable] = React.useState(false);

    const values = Form.useWatch([], form);

    React.useEffect(() => {
      form.validateFields({ validateOnly: true }).then(
        () => {
          setSubmittable(true);
        },
        () => {
          setSubmittable(false);
        }
      );
    }, [values]);

    return (
      <Button type="primary" htmlType="submit" disabled={!submittable}>
        Submit
      </Button>
    );
  };
  return (
    <Form
      form={form}
      name="validateOnly"
      layout="vertical"
      autoComplete="off"
      onFinish={onFinish}
    >
      <Form.Item
        name="title"
        label="Title"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="description"
        label="Description"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item>
        <Space>
          <SubmitButton form={form} />
          <Button htmlType="reset">Reset</Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default BranchTermsCreateForm;
